import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  accordionHeader: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '27px',
    letterSpacing: '0px',
    color: theme.palette.labraText.tertiary,
  },
  customContent: {
    borderBottom: '1px solid #E2E2E2',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    marginBottom: theme.spacing(1),
  },
}))
